import { env } from 'constants/env';
import { LogToService } from 'V2/Utilities/Logger';

import { ConfigType, HttpType } from './types';
import { createAxiosInstance } from './AxiosConfig';
import { createRequestInterceptor } from './AxiosConfig/interceptors';

declare global {
  interface Window {
    AwsWafIntegration: any;
  }
}

const baseURL = env.apiHost;

const axiosInstance = createAxiosInstance({
  baseURL,
  withCredentials: true,
  onRequestFulfilled: createRequestInterceptor(async (request) => {
    try {
      const awsWafToken: string =
        window.AwsWafIntegration && (await window.AwsWafIntegration.getToken());

      if (!!awsWafToken) {
        request.headers.set('X-Aws-Waf-Token', awsWafToken);
      }
    } catch (error: any) {
      LogToService.captureException({
        errorType: 'client',
        message: error.message,
        thread: 'Aws-Waf-Token',
        error: new Error(error),
      });
    }
  }),
});

export const httpCheckoutAPI: HttpType = {
  get: (config: ConfigType) =>
    axiosInstance.request({
      ...config,
      method: 'get',
      responseType: 'json',
      url: config.url,
      baseURL,
      withCredentials: true,
    }),
  post: (config: ConfigType) =>
    axiosInstance.request({
      ...config,
      method: 'post',
      responseType: 'json',
      url: config.url,
      baseURL,
      withCredentials: true,
    }),
};
